import { updateObject } from "utils/helpers/updateObject";
import { initialState, RolesState } from "./state";
import {
  actionTypes,
  CreateRoleFailureAction,
  CreateRoleRequestAction,
  CreateRoleSuccessAction,
  DeleteRoleFailureAction,
  DeleteRoleRequestAction,
  DeleteRoleSuccessAction,
  FetchRolesFailureAction,
  FetchRolesRequestAction,
  FetchRolesSuccessAction,
  RoleActions,
  stateStatusType,
  UpdateRoleFailureAction,
  UpdateRoleRequestAction,
  UpdateRoleSuccessAction,
} from "./actionType";

// fetchRoleRequest
const fetchRolesRequest = (
  state: RolesState,
  action: FetchRolesRequestAction
) => {
  return updateObject(state, {
    fetchRolesState: {
      ...state.fetchRolesState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchRolesSuccess = (
  state: RolesState,
  action: FetchRolesSuccessAction
) => {
  return updateObject(state, {
    fetchRolesState: {
      ...state.fetchRolesState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      roles: action.payload,
    },
  });
};

const fetchRolesFail = (state: RolesState, action: FetchRolesFailureAction) => {
  return updateObject(state, {
    fetchRolesState: {
      ...state.fetchRolesState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      roles: null,
    },
  });
};

// Create role
const createRoleRequest = (
  state: RolesState,
  action: CreateRoleRequestAction
) => {
  return updateObject(state, {
    fetchRolesState: {
      ...state.fetchRolesState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const createRoleSuccess = (
  state: RolesState,
  action: CreateRoleSuccessAction
) => {
  const newRole = state.fetchRolesState.roles ?? [];
  return updateObject(state, {
    genericRoleState: {
      ...state.genericRoleState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchRolesState: {
      ...state.genericRoleState,
      roles: [...newRole, action.payload],
    },
  });
};

const createRoleFail = (state: RolesState, action: CreateRoleFailureAction) => {
  return updateObject(state, {
    genericRoleState: {
      ...state.genericRoleState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchRolesState: {
      ...state.fetchRolesState,
      isLoading: false,
    },
  });
};

//Update Role
const updateRoleRequest = (
  state: RolesState,
  action: UpdateRoleRequestAction
) => {
  return updateObject(state, {
    fetchRolesState: {
      ...state.fetchRolesState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};
const updateRoleSuccess = (
  state: RolesState,
  action: UpdateRoleSuccessAction
) => {
  const newRole =
    state.fetchRolesState?.roles?.map((item) =>
      item.id === action.payload.id ? action.payload : item
    ) ?? [];
  return updateObject(state, {
    genericRoleState: {
      ...state.genericRoleState,
      isLoading: false,
      error: null,
      status: null,
    },
    fetchRolesState: {
      ...state.fetchRolesState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      roles: [...newRole],
    },
  });
};
const updateRoleFail = (state: RolesState, action: UpdateRoleFailureAction) => {
  return updateObject(state, {
    genericRoleState: {
      ...state.genericRoleState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchRolesState: {
      ...state.fetchRolesState,
      isLoading: false,
    },
  });
};

const deleteRoleRequest = (
  state: RolesState,
  action: DeleteRoleRequestAction
) => {
  return updateObject(state, {
    fetchRolesState: {
      ...state.fetchRolesState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
const deleteRoleSuccess = (
  state: RolesState,
  action: DeleteRoleSuccessAction
) => {
  const updatedRoles = (state.fetchRolesState.roles ?? []).filter(
    (role) => role.id !== action.payload 
  );
  return updateObject(state, {
    genericRoleState: {
      ...state.genericRoleState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchRolesState: {
      ...state.fetchRolesState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      delete: action.payload,
      roles: updatedRoles,
    },
  });
};

const deleteRoleFail = (state: RolesState, action: DeleteRoleFailureAction) => {
  return updateObject(state, {
    genericRoleState: {
      ...state.genericRoleState,
      isLoading: false,
      error: action.payload,
      delete: null,
      status: stateStatusType.FAILED,
    },
    fetchRolesState: {
      ...state.fetchRolesState,
      isLoading: false,
      delete: null,
      status: stateStatusType.FAILED,
    },
  });
};

const fetchRolesReducer = (state = initialState, action: RoleActions) => {
  switch (action.type) {
    case actionTypes.FETCH_ROLES_REQUEST:
      return fetchRolesRequest(state, action);
    case actionTypes.FETCH_ROLES_SUCCESS:
      return fetchRolesSuccess(state, action);
    case actionTypes.FETCH_ROLES_FAIL:
      return fetchRolesFail(state, action);
    case actionTypes.CREATE_ROLE_REQUEST:
      return createRoleRequest(state, action);
    case actionTypes.CREATE_ROLE_SUCCESS:
      return createRoleSuccess(state, action);
    case actionTypes.CREATE_ROLE_FAIL:
      return createRoleFail(state, action);
    case actionTypes.UPDATE_ROLE_REQUEST:
      return updateRoleRequest(state, action);
    case actionTypes.UPDATE_ROLE_SUCCESS:
      return updateRoleSuccess(state, action);
    case actionTypes.UPDATE_ROLE_FAIL:
      return updateRoleFail(state, action);
    case actionTypes.DELETE_ROLE_REQUEST:
      return deleteRoleRequest(state, action);
    case actionTypes.DELETE_ROLE_SUCCESS:
      return deleteRoleSuccess(state, action);
    case actionTypes.DELETE_ROLE_FAIL:
      return deleteRoleFail(state, action);
    default:
      return state;
  }
};

export default fetchRolesReducer;
